import { memo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Login from './pages/Login'
import Menu from './pages/Menu'
import UnloadList from './pages/bid/UnloadList'
import BidList from './pages/bid/BidList'
import BidGroup from './pages/bid/BidGroup'
import BidRegister from './pages/bid/BidRegister'
import BidManager from './pages/bid/BidManager'
import DataInput from './pages/bid/DataInput'
import DataInputList from './pages/bid/DataInputList'
import BidHistory from './pages/entry/BidHistory'
import UserInfo from './pages/entry/UserInfo'
import UnloadMonitor from './pages/signnage/UnloadMonitor'
import BidListMonitor from './pages/signnage/BidListMonitor'
import BidHistoryMonitor from './pages/signnage/BidHistoryMonitor'
import ShipList from './pages/maintenance/ShipList'
import TraderList from './pages/maintenance/TraderList'
import FishSpecList from './pages/maintenance/FishSpecList'
import ContainerList from './pages/maintenance/Container'
import UserList from './pages/maintenance/UserList'
import StandardList from './pages/maintenance/StandardList'
import OriginalFishSpecList from './pages/maintenance/OriginalFishSpecList'
import OriginalShipList from './pages/maintenance/OriginalShipList'
import Home from './pages/Home'
import BidMastaMenu from './pages/menu/BidMastaMenu'
import SystemMastaMenu from './pages/menu/SystemMastaMenu'
import SignageMenu from './pages/menu/SignageMenu'
import ShipGroupList from './pages/maintenance/ShipGroupList'
import StandardGroupList from './pages/maintenance/StandardGroupList'
import MemoList from './pages/maintenance/MemoList'
import CommentList from './pages/maintenance/CommentList'
import BidPersonList from './pages/maintenance/BidPersonList'
import HomeMobile from './pages/mobile/Home'
import BidGroupMobile from './pages/mobile/BidGroup'
import BidManagerMobile from './pages/mobile/BidManager'
import BidRegisterMobile from './pages/mobile/BidRegister'
import Mobile from './pages/Mobile'
import UiTest from './pages/UiTest'

const AppRouter = memo(() => {
  return (
    <Router>
        <Routes>
            <Route path="/"                     element={<Login />} />
            <Route path="/mobile"               element={<Mobile />} />
            <Route path="/home"                 element={<Home />} />
            <Route path="/bidMastaMenu"         element={<BidMastaMenu />} />
            <Route path="/systemMastaMenu"      element={<SystemMastaMenu />} />
            <Route path="/signageMenu"          element={<SignageMenu />} />
            <Route path="/unloadList"           element={<UnloadList />} />
            <Route path="/bidList"              element={<BidList />} />
            <Route path="/bidGroup"             element={<BidGroup />} />
            <Route path="/bidRegister"          element={<BidRegister />} />
            <Route path="/bidManager"           element={<BidManager />} />
            <Route path="/dataInput"            element={<DataInput />} />
            <Route path="/dataInputList"        element={<DataInputList />} />
            <Route path="/bidHistory"           element={<BidHistory />} />
            <Route path="/userInfo"             element={<UserInfo />} />
            <Route path="/unloadMonitor"        element={<UnloadMonitor />} />
            <Route path="/bidListMonitor"       element={<BidListMonitor />} />
            <Route path="/bidHistoryMonitor"    element={<BidHistoryMonitor />} />
            <Route path="/shipGroupList"        element={<ShipGroupList />} />
            <Route path="/shipList"             element={<ShipList />} />
            <Route path="/standardList"         element={<StandardList />} />
            <Route path="/standardGroupList"    element={<StandardGroupList />} />
            <Route path="/traderList"           element={<TraderList />} />
            <Route path="/fishSpecList"         element={<FishSpecList />} />
            <Route path="/containerList"        element={<ContainerList />} />
            <Route path="/bidPersonList"        element={<BidPersonList />} />
            <Route path="/memoList"             element={<MemoList />} />
            <Route path="/commentList"          element={<CommentList />} />
            <Route path="/userList"             element={<UserList />} />
            <Route path="/originalFishSpecList" element={<OriginalFishSpecList />} />
            <Route path="/originalShipList"     element={<OriginalShipList />} />
            <Route path="/homeMobile"           element={<HomeMobile />} />
            <Route path="/bidGroupMobile"       element={<BidGroupMobile />} />
            <Route path="/bidManagerMobile"     element={<BidManagerMobile />} />
            <Route path="/bidRegisterMobile"    element={<BidRegisterMobile />} />
            <Route path="/uiTest"               element={<UiTest />} />
            <Route
                path="*"
                element={
                <main>
                    <p>一致するものがありません</p>
                </main>
                }
                />
        </Routes>
    </Router>
  );
});

export default AppRouter;